import React from 'react';

export default class Version extends React.Component {

    render() {
        return (
            <div className="d-flex justify-content-center h-100 align-items-center font-weight-bold font-size-16">
               version: {process.env.REACT_APP_VERSION}
            </div>
        )
    }
}
